import { useContext } from "react";
import common from '../../common.module.css';
import { ModalCopyMaterial } from "../..";
import Select from "@UI/New/Select";
import { filterOptionsByLabel } from "@/helpers/new/filterOptionsByLabel";
import { compareOptionsByLabel } from "@/helpers/new/compareOptionsByLabel";

export const Direction = () => {
    const { 
            state, 
            setFieldInState,
            setCourses, 
            directions, 
            loadingDirections,
            setMaterials
        } = useContext(ModalCopyMaterial);

    const directionsOptions = directions.map((direction) => ({label: direction.name, value: direction.id}));

    const fieldsDirections = {
        loading: loadingDirections,
        showSearch: true,
        allowClear: true,
        filterSort: compareOptionsByLabel,
        filterOption: filterOptionsByLabel,
        onChange: value => {
            setFieldInState({field: 'course', value: null});
            setFieldInState({field: 'topic_id', value: null});
            setFieldInState({field:'direction', value});
            setCourses({})
            setMaterials({})
        },
        options: directionsOptions,
        value: state?.direction,
        placeholder: 'Выберите курс',
        notFoundContent: "Курсы не найдены"
    };

    return (
        <div className={common.wrapper}>
            <span>Выберите курс</span>
            <Select 
                wrapperClassName={common.wrapperSelect} 
                className={common.select} 
                fields={fieldsDirections} 
            />
        </div>
    )
}
